<template>
  <div class="ai-agent-sidebar">
    <!-- Backdrop for mobile -->
    <transition name="fade">
      <div
        v-if="isOpen && isMobile"
        class="ai-agent-sidebar__backdrop"
        @click="$emit('close')"
      />
    </transition>

    <!-- Sidebar panel -->
    <transition name="slide-right">
      <div
        v-if="isOpen"
        :class="['ai-agent-sidebar__panel', { 'ai-agent-sidebar__panel--mobile': isMobile }]"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AiAgentSidebar',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isMobile (): boolean {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
});
</script>

<style lang="scss" scoped>
.ai-agent-sidebar {
  &__backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999;
  }

  &__panel {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    height: 100dvh;
    width: 100%;
    max-width: 560px;
    background-color: #f5f5f5;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &--mobile {
      max-width: 100%;
    }
  }
}

/* Backdrop fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Sidebar slide transition */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
}
</style>
